export default __webpack_public_path__ + "static/media/Audio-Number-2.d726dc1f.mp3";